import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MainLayout } from "~/components/layout/layout.jsx";
import { UserModal } from "~/components/profile/userModal.jsx";
import { updateIfNeeded } from "~/lib/helpers.js";
import { aanmeldingenActions, daysActions, flightsActions } from "~/redux/actions.js";
import { AddDayModal } from "../addDay/addDayModal.jsx";
import { AanmeldForm } from "./components/AanmeldForm.jsx";
import { AanmeldHeader } from "./components/AanmeldHeader.jsx";
import { DayInfo } from "./components/DayInfo.jsx";
import { AanmeldLijstContent } from "./components/aanmeldLijstContent.jsx";
import { clubHasFinance } from "~/featureMatrix.jsx";
import { api } from "~/lib/api.js";

export const AanmeldLijstComponent = ({
  history,
  match,
  kist_aanmelding,
  club,
  profile,
  aanmeldingen,
  flights,
  days,
  saveDay,
  getBaseData,
  getAanmeldingen,
  saveAanmelding,
  saveRegistration,
  getAllDays,
  openDay,
}) => {
  useEffect(() => {
    updateIfNeeded(flights.lastUpdatedBaseData, getBaseData);
  }, [flights.lastUpdatedBaseData, getBaseData]);

  useEffect(() => {
    updateIfNeeded(
      days.lastUpdated,
      getAllDays,
      () => days.lastUpdated && openDay(match.params.id)
    );
  }, [days.lastUpdated, getAllDays, match.params.id, openDay]);

  useEffect(() => {
    const fetchData = async () => {
      if (!match.params.id) return;
      const resp = await getAanmeldingen({
        dag_id: match.params.id,
        normalizeAsVliegers: false,
      });
      if (!resp) history.push("/register");
    };
    fetchData();
  }, [match.params.id, getAanmeldingen, history]);

  const [loading, setLoading] = useState(false);
  const [openedPilot, setOpenPilot] = useState(null);
  const [openModal, setmodalOpen] = useState();
  const [activeAanmelding, setActiveAanmelding] = useState(-1);

  const editAanmelding = (aanmelding) => {
    setActiveAanmelding(aanmelding);
    setmodalOpen("aanmeld");
  };

  // in case of vouchers we download them here
  const has_finance = clubHasFinance()
  const [vouchers, setVouchers] = useState([]);
  const getVouchers = async (date) => {
    let url = `financial/vouchers.json?page=${1}&open=1&only=1&date=${date}`;
    const data = await api.get(url);
    if (data) {
      setVouchers(data.results)
    }
  };
  useEffect(() => {
    if (has_finance) {
      getVouchers(days.activeDay.datum);
    }
  }, [has_finance, days.activeDay.datum, days.activeDay.is_vliegend]);


  const handleSaveDay = (data) => {
    const day = saveDay(data);
    if (day) {
      setmodalOpen(null);
    }
  };

  const afmelden = async (lid, aangemeld = false, remark = "") => {
    setLoading(true);
    await saveAanmelding({
      action: aangemeld ? "meld_aan" : "meld_af",
      dag_id: days.activeDay.dag_id,
      remark: remark,
      lid,
    });
    setLoading(false);
  };

  const currentAanmelding = aanmeldingen.aanmeldingen?.find(
    // (a) => a.id === activeAanmelding
    (aanmelding) => aanmelding.vlieger?.id === profile.id
  );

  const types = flights.club_kisten
    .reduce((all, kist) => {
      const value = kist.type_group || kist.type;
      value && !all.includes(value) && all.push(value);
      return all;
    }, [])
    .sort();

  return (
    <MainLayout
      history={history}
      isLoading={days.isPending || aanmeldingen.isPending}
    >
      <AddDayModal
        profile={profile}
        link_to={null}
        visible={openModal === "day"}
        onOk={handleSaveDay}
        onCancel={() => setmodalOpen(null)}
        confirmLoading={days.isPending}
        activeDay={days.activeDay}
        club={club}
        history={history}
        existingLijsten={aanmeldingen?.registration_lists}
      />

      {activeAanmelding !== -1 && (
        <AanmeldForm
          visible={openModal === "aanmeld"}
          activeAanmelding={activeAanmelding}
          closeModal={() => {
            setmodalOpen(null);
            setActiveAanmelding(-1);
          }}
          saveAanmelding={saveAanmelding}
          diensten={aanmeldingen.diensten}
          profile={profile}
          activeDay={days.activeDay}
          types={types}
          vliegers={flights.vliegers}
          kist_aanmelding={profile.vliegt && kist_aanmelding}
          limit_signup_time={club.limit_signup_time}
          registration_lists={aanmeldingen?.registration_lists}
          n_instructors={aanmeldingen.aanmeldingen?.filter((a) => a.as_instructeur && a.aangemeld).length ?? 0}
          saveRegistration={saveRegistration}
        />
      )}

      <UserModal
        visible={openedPilot && openedPilot.id}
        onClose={() => setOpenPilot(null)}
        pilot={openedPilot}
        currentUser={profile}
      />

      <AanmeldHeader
        days={days}
        profile={profile}
        currentAanmelding={currentAanmelding}
        loading={loading}
        club={club}
        match={match}
        editAanmelding={editAanmelding}
        afmelden={afmelden}
        history={history}
        setmodalOpen={setmodalOpen}
      />

      <DayInfo activeDay={days.activeDay} profile={profile} club={club} />

      <AanmeldLijstContent
        days={days}
        aanmeldingen={aanmeldingen}
        club={club}
        flights={flights}
        profile={profile}
        currentAanmelding={currentAanmelding}
        setOpenPilot={setOpenPilot}
        editAanmelding={editAanmelding}
        afmelden={afmelden}
        vouchers={vouchers || []}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  aanmeldingen: state.aanmeldingen,
  days: state.days,
  flights: state.flights,
  club: state.persist.club,
  profile: state.persist.profile,
  kist_aanmelding: state.persist.kist_aanmelding,
  lastUpdated: state.materiaal.lastUpdated,
});

const mapDispatchToProps = (dispatch) => ({
  saveDay: (d) => dispatch(daysActions.saveDay(d)),
  getBaseData: (d) => dispatch(flightsActions.getBaseData(d)),
  openDay: (d) => dispatch(daysActions.openDay(d)),
  getAanmeldingen: (d) => dispatch(aanmeldingenActions.getAanmeldingen(d)),
  saveAanmelding: (d) => dispatch(aanmeldingenActions.saveAanmelding(d)),
  saveRegistration: (d) => dispatch(aanmeldingenActions.saveRegistration(d)),
  getAllDays: (d) => dispatch(daysActions.getAllDays(d)),
});

export const AanmeldLijstPagina = connect(
  mapStateToProps,
  mapDispatchToProps
)(AanmeldLijstComponent);
